



























import { Vue, Component } from 'vue-property-decorator'
import ItemsTick from '@/components/ItemsTick.vue'

@Component({
  components: {
    ItemsTick
  }
})

export default class InfoBottom extends Vue {
  items = [
    'Скачайте и откройте приложение <span class="accent">WB&nbsp;Партнеры</span>',
    'Введите и подтвердите номер телефона', 'Нажмите «Стать самозанятым»', 'Пройдите простую процедуру регистрации'
  ]
}
